import { render, staticRenderFns } from "./ChangeCredit.vue?vue&type=template&id=48368107&"
import script from "./ChangeCredit.vue?vue&type=script&lang=ts&"
export * from "./ChangeCredit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports